import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    fetchSignupRequirementsForDataModule,
    fetchSignupRequirementsSuccess,
    fetchSignupRequirementsError,
    fetchSignupRequirementsReset,
} from '@perpay-web/fintech/actions/entities/signupRequirements';
import { SIGNUP_REQUIREMENTS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useFetchSignupRequirementsDataModule = () => {
    const dataModule = useDataModule(() =>
        authenticatedJsonFetch(SIGNUP_REQUIREMENTS_ENDPOINT),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: fetchSignupRequirementsForDataModule,
        error: fetchSignupRequirementsError,
        success: fetchSignupRequirementsSuccess,
        reset: fetchSignupRequirementsReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useFetchSignupRequirementsDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseFetchSignupRequirementsDataModuleProvider,
    useFetchSignupRequirementsContext,
] = createContextProvider(providerFactory);
